<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors">
        {{ error }}
      </p>
    </div>

    <div :class="{'has-error':errors.event}">
      <select
        :value="event"
        name="event"
        class="form-control"
        @change="handleChange"
      >
        <option value="" selected="selected">
          Select Event(s)
        </option>
        <option v-for="(name, $id) in config.eventsWithDataClassifications" :value="$id">
          {{ name }}
        </option>
      </select>
    </div>
    Of the last
    <span :class="{'has-error':errors.amount || errors.lessthan}">
      <input :value="amount" name="amount" class="form-control input-numeric" @change="handleChange">
    </span>
    <select :value="ongoing" name="ongoing" class="form-control" @change="handleChange">
      <option value="true">
        Events (including in window events)
      </option>
      <option value="false">
        Events (excluding in window events)
      </option>
    </select>
    at least
    <span :class="{'has-error':errors.classified || errors.lessthan}">
      <input :value="classified" class="form-control input-numeric" name="classified" @change="handleChange">
    </span>
    were categorized
    <span :class="{'has-error':errors.dataClassification}">
      <select
        v-if="event !== null"
        :value="dataClassification"
        name="dataClassification"
        class="form-control"
        @change="handleChange"
      >
        <option value="" selected="selected">Select Category</option>
        <option v-for="(classification, $id) in config.dataClassificationsByEvent[event]" :value="$id">{{ classification }}
        </option>
      </select>.
    </span>
  </div>
</template>
<script type="text/javascript">
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';

  export default {
    extends: BaseComponent,

    props: {
      amount: [Number, String],
      classified: [Number, String],
      dataClassification: String,
      event: {
        type: [Number, String],
        default: null
      },
      ongoing: {
        // This is "true" or "false" as a string. The PHP code is specifically expecting a string. :-o
        type: String,
        default: "false"
      },
      id: String
    },
    methods: {
      validate: function () {
        this.errors = {};

        if (!this.dataClassification) {
          this.errors.dataClassification = 'Please select a Classification.';
        }

        if (!this.isInteger(this.amount) || this.amount < 1) {
          this.errors.amount = 'The number of events to look at must be a whole number (ex. 3) greater than 0.'
        }

        if (!this.isInteger(this.classified) || this.classified < 0) {
          this.errors.classified = 'The number of classified events must be a whole number (ex. 3).';
        }

        if (this.errors.amount === undefined && this.errors.classified === undefined) {
          if (Number(this.amount) < Number(this.classified)) {
            this.errors.lessthan = "The number of events to look at must be greater than or equal to the number of events which must be classified.";
          }
        }

        if (!this.event) {
          this.errors.event = 'Please select an Event.';
        }

        return Object.keys(this.errors).length === 0;
      }
    }
  };
</script>
